import { __rest, __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef, useRef, useEffect } from 'react';
import styles from './Button.module.scss.js';

var Button = forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.color, color = _c === void 0 ? 'primary' : _c, _d = _a.type, type = _d === void 0 ? 'button' : _d, _e = _a.variant, variant = _e === void 0 ? 'contained' : _e, _f = _a.size, size = _f === void 0 ? 'm' : _f, className = _a.className, children = _a.children, _g = _a.as, TagName = _g === void 0 ? 'button' : _g, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, disabled = _a.disabled, _h = _a.isLoading, isLoading = _h === void 0 ? false : _h, autoFocus = _a.autoFocus, rest = __rest(_a, ["color", "type", "variant", "size", "className", "children", "as", "leftIcon", "rightIcon", "disabled", "isLoading", "autoFocus"]);
    var localRef = useRef(null);
    var buttonRef = (ref || localRef);
    useEffect(function () {
        if (autoFocus) {
            setTimeout(function () {
                var _a;
                (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 0);
        }
    }, [buttonRef, autoFocus]);
    var classNames = clsx(styles.button, (_b = {},
        // colors
        _b[styles.buttonPrimary] = color === 'primary',
        _b[styles.buttonSecondary] = color === 'secondary',
        _b[styles.buttonDark] = color === 'dark',
        // variants
        _b[styles.buttonOutlined] = variant === 'outlined',
        _b[styles.buttonInverted] = variant === 'inverted',
        _b[styles.buttonText] = variant === 'text',
        // sizes
        _b[styles.buttonExtraSmall] = size === 'xs',
        _b[styles.buttonMedium] = size === 'm',
        _b[styles.buttonLarge] = size === 'l',
        _b[styles.buttonLoading] = isLoading,
        _b), className);
    var content = (jsxs(Fragment, { children: [leftIcon && jsx("div", __assign({ className: styles['buttonIconLeft'] }, { children: leftIcon })), children, rightIcon && jsx("div", __assign({ className: styles['buttonIconRight'] }, { children: rightIcon }))] }));
    if (TagName === 'a') {
        return (jsx("a", __assign({ className: classNames, ref: buttonRef }, rest, { children: content })));
    }
    return (jsx("button", __assign({}, rest, { type: type, disabled: disabled, className: classNames, ref: buttonRef }, { children: content })));
});

export { Button };
